import { FormikProps } from 'formik';

/**
 * Field components in this app (TextInput, Dropdown, RadioGroup, TextArea, DateTimePickerInput)
 * don't support onBlur, so this marks a field "touched" (dirty) the moment it's edited — keeping
 * errors from showing on untouched fields as soon as any single field is changed (formik
 * validates the whole form on every change by default).
 */
export function useSetFieldValueTouched<T>(formik: FormikProps<T>) {
  return <K extends keyof T>(field: K, value: T[K]) => {
    formik.setFieldValue(field as string, value);
    formik.setFieldTouched(field as string, true, false);
  };
}
